class NewsletterService {
    constructor(selector = ".js-nl-submit") {
        this.buttonSelector = selector;
        document.addEventListener("DOMContentLoaded", () => this.bindEvents());
    }

    bindEvents() {
        document.addEventListener("click", (event) => {
            const button = event.target.closest(this.buttonSelector);
            if (!button) return;

            this.updateButtonHref(button);
        });
    }

    updateButtonHref(button) {
        const formElement = button.closest(".js-nl-form");
        const emailInput = formElement?.querySelector('input[name="email"]');
        const emailValue = emailInput?.value?.trim() || "";

        const baseUrl = button.getAttribute("href");
        if (!baseUrl) return;

        let finalUrl = baseUrl;

        const isUrlParsable =
            baseUrl.startsWith("http://") ||
            baseUrl.startsWith("https://") ||
            baseUrl.startsWith("/") ||
            baseUrl.startsWith("?");

        if (emailValue) {
            if (isUrlParsable) {
                const url = new URL(baseUrl, window.location.origin);
                url.searchParams.set("email", emailValue);
                finalUrl = url.toString();
            } else {
                const separator = baseUrl.includes("?") ? "&" : "?";
                finalUrl = `${baseUrl}${separator}email=${encodeURIComponent(emailValue)}`;
            }
        }

        button.setAttribute("href", finalUrl);
    }
}

export default NewsletterService;
